import { render } from "./UnifiedChatModal.vue?vue&type=template&id=925b3ae2"
import script from "./UnifiedChatModal.vue?vue&type=script&lang=js"
export * from "./UnifiedChatModal.vue?vue&type=script&lang=js"

import exportComponent from "/deploy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__